import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdBackspace } from 'react-icons/md';

const Backspace: React.FC<IconBaseProps> = (props) => (
  <MdBackspace {...props} />
);

export default Backspace;
